import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classes from './UploadAuxiliaryPopup.module.css';
import closeIcon from '../../../../../assests/lesson/close-icon.png'
import BackdropPopup from '../../../../lms-shared/UI/Popups/BackdropPopup/BackdropPopup';

const UploadAuxiliaryPopup = ({ setClose, handleAuxiliaryFileReader }) => {
    const texts = useSelector(state => state.translate.texts);
    const [url, setUrl] = useState()
    return (
        <BackdropPopup myWidth={'402px'} myHeight={'192px'}>
            <div className={classes.Header}>
                <h2>{texts.uploadFiles}</h2>
                <img src={closeIcon} alt="Close" className={classes.CloseIcon} onClick={() => setClose(false)} />
            </div>
            <div className={classes.Content}>
                <div className={classes.UploadSection}>
                    {texts.uploadFile}
                    <input className={classes.FileInput} type="file" accept="*" onChange={(e)=>handleAuxiliaryFileReader(e)} />
                </div>
                <p className={classes.AddLink}>{texts.addLink}</p>
                <div className={classes.TextSection}>
                    <input className={classes.LinkInput} type="text" onChange={(e)=>setUrl(e.target.value)}/>
                    <button className={classes.ApproveButton}  onClick={(e) =>{ handleAuxiliaryFileReader(e, url)}}>{texts.ok}</button>
                </div>
            </div>
        </BackdropPopup>
    );
};

export default UploadAuxiliaryPopup;